<div class="grid formgrid">
   <div class="field col-12 md:col-6 md:pr-6 pr-0">

      <div class="custom-skeleton p-4">
         
         <div class="d-flex flex justify-content-between mb-3">

            <div>
               <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
               <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>

            <div
            [ngClass]="{ 'dir-rtl': lang === 'en', 'dir-ltr': lang === 'ar' }"
            >
               <p-skeleton width="10rem" styleClass="mb-2"></p-skeleton>
               <p-skeleton width="5rem" styleClass="mb-2"></p-skeleton>
            </div>

         </div>

         <p-skeleton width="100%" height="150px"></p-skeleton>

      </div>

   </div>
</div>